import Form from './form';
import FormItem from './form-item';

Form.Item = FormItem;

export default Form;
